"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.classes)
    }, [
        (0, vue_1.createTextVNode)("(" + (0, vue_1.toDisplayString)(_ctx.description) + ")", 1)
    ], 2)), [
        [_directive_i18n]
    ]);
}
